// extracted by mini-css-extract-plugin
module.exports = {"moreUpdatesSection":"MoreUpdatesSection-module--moreUpdatesSection--1rqPf"};